import { useTranslation } from "react-i18next";

import { Table, UnstyledButton } from "@mantine/core";

import { useFormatters } from "@prostocheck/i18n";
import { Badge, Card, ReceiptTypeBadge } from "@prostocheck/ui";

import { IReceiptsTableProps } from "./receipts-table.models";

export const ReceiptsTable = ({
  receipts,
  onSelectReceipt,
}: IReceiptsTableProps) => {
  const { t } = useTranslation();
  const { formatDateTime, formatPrice } = useFormatters();

  return (
    <Card className="p-0">
      <Table.ScrollContainer minWidth={640}>
        <Table highlightOnHover verticalSpacing="sm" horizontalSpacing="md">
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{t("receipts.columns.time")}</Table.Th>
              <Table.Th>{t("receipts.columns.fiscalNumber")}</Table.Th>
              <Table.Th>{t("receipts.columns.type")}</Table.Th>
              <Table.Th>{t("receipts.columns.payment")}</Table.Th>
              <Table.Th ta="right">{t("receipts.columns.total")}</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {receipts.map(receipt => (
              <Table.Tr key={receipt.fiscalNumber}>
                <Table.Td c="dimmed">
                  {formatDateTime(receipt.issuedAt)}
                </Table.Td>
                <Table.Td>
                  <UnstyledButton
                    onClick={() => onSelectReceipt(receipt.fiscalNumber)}
                    className="font-medium text-ink-900 hover:text-brand-700"
                  >
                    {receipt.fiscalNumber}
                  </UnstyledButton>
                  {receipt.isOffline && (
                    <Badge tone="warning" className="ml-2">
                      {t("receipts.offline")}
                    </Badge>
                  )}
                </Table.Td>
                <Table.Td>
                  <ReceiptTypeBadge type={receipt.type} />
                </Table.Td>
                <Table.Td c="dimmed">
                  {t(`common:paymentMethod.${receipt.paymentMethod}`)}
                </Table.Td>
                <Table.Td ta="right" fw={500}>
                  {formatPrice(receipt.total)}
                </Table.Td>
              </Table.Tr>
            ))}
            {receipts.length === 0 && (
              <Table.Tr>
                <Table.Td colSpan={5} c="dimmed" ta="center" py={40}>
                  {t("receipts.empty")}
                </Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Card>
  );
};
